import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

function ThemeLab({ currentTheme, isOpen, onCycle, onClose }) {
    const rootRef = useRef(null);

    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const handlePointerDown = (event) => {
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('pointerdown', handlePointerDown);

        return () => {
            document.removeEventListener('pointerdown', handlePointerDown);
        };
    }, [isOpen, onClose]);

    return (
        <div className="theme-lab" ref={rootRef}>
            <button
                type="button"
                className="theme-lab-trigger"
                onClick={onCycle}
                aria-label={`Switch theme from ${currentTheme.label}`}
            >
                <span className="theme-lab-trigger-label">Theme Lab</span>
                <strong>{currentTheme.label}</strong>
            </button>

            <AnimatePresence>
                {isOpen && (
                    <motion.aside
                        className="theme-lab-drawer"
                        initial={{ opacity: 0, x: 28 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 28 }}
                        transition={{ duration: 0.28, ease: 'easeOut' }}
                    >
                        <button
                            type="button"
                            className="theme-lab-close"
                            onClick={onClose}
                            aria-label="Close theme popup"
                        >
                            X
                        </button>
                        <h3>Choose a different view</h3>
                        <p className="theme-lab-note">Use Theme Lab to explore the portfolio themes.</p>
                    </motion.aside>
                )}
            </AnimatePresence>
        </div>
    );
}

export default ThemeLab;
